//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatConfiguredTime, formatDate } from '../../../../../../components/helpers.js'

export default {
  data () {
    return {
      date: this.getCurrentDate(),
      time: this.getCurrentTime(),
      intervalId: null
    }
  },
  mounted () {
    this.startClock()
  },
  beforeDestroy () {
    this.stopClock()
  },
  methods: {
    getCurrentDate () {
      const now = new Date()
      return formatDate(now)
    },
    getCurrentTime () {
      const now = new Date()
      return formatConfiguredTime(now, { hour: true, min: true, sec: true })
    },
    startClock () {
      this.intervalId = setInterval(() => {
        this.time = this.getCurrentTime()
        this.date = this.getCurrentDate()
      }, 1000)
    },
    stopClock () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    }
  }
}
